// Story 11.9 — the admin invite write behind Screen 22 (Create user).
//
// 201, not 200, and the body carries NO password and NO hash by contract: the
// invitation email is the only channel the credential travels on.

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import { ADMIN_USERS_QUERY_KEY } from "@/hooks/queries/useAdminUsers";
import type {
  AdminInviteUserData,
  AdminInviteUserRequest,
} from "@/hooks/queries/admin-users-types";

export function useInviteUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: AdminInviteUserRequest) =>
      apiFetch<AdminInviteUserData>("/admin/users/invite", { method: "POST", body }),
    onSuccess: () => {
      // The new user belongs in the directory the screen returns to; invalidate the
      // list PREFIX so whichever filter state the admin lands on is refetched.
      void queryClient.invalidateQueries({ queryKey: [ADMIN_USERS_QUERY_KEY] });
    },
  });
}
